<div class="component-container">
  <div *ngIf="!isApplicationService.isAppIos()" class="inside-container">
    <div
      class="grid grid-cols-1 gap-8 mb-10"
      [ngClass]="{
        'md:grid-cols-[1fr_3fr]': languageService.isEliteEnabled,
        'md:grid-cols-[1fr_2fr]': !languageService.isEliteEnabled
      }"
    >
      <div class="bg-theme-white rounded p-6 flex flex-row md:flex-col items-center justify-center">
        <img
          src="assets/images/svg-illustrations/pricing.svg"
          class="md:mb-20 mr-10 md:mr-0 min-w-0"
        />
        <span
          class="min-w-[154px] font-extrabold text-26"
          [innerHTML]="'pricing.formule' | translate"
        ></span>
      </div>

      <div
        *ngIf="currentSubscriptionTier$ | async as currentSubscriptionTier"
        class="grid grid-cols-1 gap-8"
        [ngClass]="{
          'md:grid-cols-3': languageService.isEliteEnabled,
          'md:grid-cols-2': !languageService.isEliteEnabled
        }"
      >
        <div class="pricing-block free-gradient">
          <div class="pricing-block_title">
            {{ 'pricing.gratuit' | translate }}
          </div>
          <div
            class="pricing-block_price"
            *ngIf="!languageService.displaySubscriptionDetailsOnPricingPage"
          >
            <div class="pricing-block_price-from invisible">
              {{ 'premium.a_partir' | translate }}
            </div>
            <div class="pricing-block_price-content">
              <div class="pricing-block_price-value">0&nbsp;€</div>
              <div class="pricing-block_price-permonth">
                /&nbsp;{{ 'premium.par_mois' | translate }}
              </div>
            </div>
          </div>
          <div class="pricing-block_features" *ngIf="pricingService.freePricingBlocks">
            <app-pricing-block-feature
              *ngFor="let block of pricingService.freePricingBlocks"
              [block]="block"
            ></app-pricing-block-feature>
          </div>
          <div
            class="flex items-center justify-center h-[200px]"
            *ngIf="!pricingService.freePricingBlocks"
          >
            <app-loader-dots [white]="true"></app-loader-dots>
          </div>
          <div
            class="pricing-block_payment-3x"
            *ngIf="currentSubscriptionTier === SubscriptionTier.FREE"
          >
            {{ 'pricing.formule_actuelle' | translate }}
          </div>
        </div>
        <ng-container *ngIf="offers | offersByTier as offersByTier">
          <div class="pricing-block premiumplus-gradient">
            <div class="pricing-block_title">
              {{ 'pricing.premium_plus' | translate }}
            </div>
            <ng-container *ngIf="offers && pricingService.premiumPlusPricingBlocks">
              <div
                class="pricing-block_price"
                *ngIf="!languageService.displaySubscriptionDetailsOnPricingPage"
              >
                <div class="pricing-block_price-from">
                  {{ 'premium.a_partir' | translate }}
                </div>
                <div class="pricing-block_price-content">
                  <div class="pricing-block_price-value">
                    {{
                      Math.floor(
                        offersByTier[SubscriptionTier.PREMIUM_PLUS][
                          offersByTier[SubscriptionTier.PREMIUM_PLUS].length - 1
                        ].price /
                          offersByTier[SubscriptionTier.PREMIUM_PLUS][
                            offersByTier[SubscriptionTier.PREMIUM_PLUS].length - 1
                          ].durationInMonths
                      )
                    }}&nbsp;€
                  </div>
                  <div class="pricing-block_price-permonth">
                    /&nbsp;{{ 'premium.par_mois' | translate }}
                  </div>
                </div>
              </div>
              <div
                class="pricing-block_pricedetails"
                *ngIf="languageService.displaySubscriptionDetailsOnPricingPage"
              >
                <div
                  *ngFor="let offer of offersByTier[SubscriptionTier.PREMIUM_PLUS]"
                  class="offer-row"
                >
                  <div class="offer-row-duration">
                    {{ offer.displayedDuration }}
                  </div>
                  <div class="offer-row-price">
                    <div class="offer-row-totalprice">{{ offer.price }}&nbsp;€</div>
                    <div *ngIf="offer.durationInMonths > 1" class="offer-row-permonthprice">
                      {{ offer.price / offer.durationInMonths | number : '1.2-2' : 'fr' }}€&nbsp;/{{
                        'premium.par_mois' | translate
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="pricing-block_features">
                <app-pricing-block-feature
                  *ngFor="let block of pricingService.premiumPlusPricingBlocks"
                  [block]="block"
                ></app-pricing-block-feature>
              </div>
            </ng-container>
            <div
              class="flex items-center justify-center h-[200px]"
              *ngIf="!offers || !pricingService.premiumPlusPricingBlocks"
            >
              <app-loader-dots [white]="true"></app-loader-dots>
            </div>
            <div
              class="pricing-block_buttons"
              *ngIf="currentSubscriptionTier !== SubscriptionTier.ELITE"
            >
              <a
                matRipple
                [matRippleCentered]="false"
                [matRippleUnbounded]="true"
                [matRippleRadius]="50"
                class="btn-nnki btn-nnki-100 btn-nnki-white text-theme-black border-white"
                [routerLink]="['/app/premium/order-premium', SubscriptionTier.PREMIUM_PLUS]"
              >
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.FREE">{{
                  'pricing.je_minscris' | translate
                }}</ng-container>
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.PREMIUM_PLUS">{{
                  'pricing.prolonger' | translate
                }}</ng-container>
              </a>
              <div class="pricing-block_payment-3x">
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.FREE">{{
                  'pricing.paiement_3_fois' | translate
                }}</ng-container>
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.PREMIUM_PLUS">{{
                  'pricing.formule_actuelle' | translate
                }}</ng-container>
              </div>
            </div>
          </div>
          <div class="pricing-block elite-gradient" *ngIf="languageService.isEliteEnabled">
            <div class="pricing-block_title">
              {{ 'pricing.elite' | translate }}
            </div>
            <ng-container *ngIf="offers && pricingService.elitePricingBlocks">
              <div
                class="pricing-block_price"
                *ngIf="!languageService.displaySubscriptionDetailsOnPricingPage"
              >
                <div class="pricing-block_price-from">
                  {{ 'premium.a_partir' | translate }}
                </div>
                <div class="pricing-block_price-content">
                  <div class="pricing-block_price-value">
                    {{
                      Math.floor(
                        offersByTier[SubscriptionTier.ELITE][
                          offersByTier[SubscriptionTier.ELITE].length - 1
                        ].price /
                          offersByTier[SubscriptionTier.ELITE][
                            offersByTier[SubscriptionTier.ELITE].length - 1
                          ].durationInMonths
                      )
                    }}&nbsp;€
                  </div>
                  <div class="pricing-block_price-permonth">
                    /&nbsp;{{ 'premium.par_mois' | translate }}
                  </div>
                </div>
              </div>
              <div
                class="pricing-block_pricedetails"
                *ngIf="languageService.displaySubscriptionDetailsOnPricingPage"
              >
                <div *ngFor="let offer of offersByTier[SubscriptionTier.ELITE]" class="offer-row">
                  <div class="offer-row-duration">
                    {{ offer.displayedDuration }}
                  </div>
                  <div class="offer-row-price">
                    <div class="offer-row-totalprice">{{ offer.price }}&nbsp;€</div>
                    <div *ngIf="offer.durationInMonths > 1" class="offer-row-permonthprice">
                      {{ offer.price / offer.durationInMonths | number : '1.2-2' : 'fr' }}€&nbsp;/{{
                        'premium.par_mois' | translate
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="pricing-block_features">
                <app-pricing-block-feature
                  *ngFor="let block of pricingService.elitePricingBlocks"
                  [block]="block"
                ></app-pricing-block-feature>
              </div>
            </ng-container>
            <div
              class="flex items-center justify-center h-[200px]"
              *ngIf="!offers || !pricingService.elitePricingBlocks"
            >
              <app-loader-dots [white]="true"></app-loader-dots>
            </div>
            <div class="pricing-block_buttons">
              <a
                matRipple
                [matRippleCentered]="false"
                [matRippleUnbounded]="true"
                [matRippleRadius]="50"
                class="btn-nnki btn-nnki-100 btn-nnki-gold text-black"
                [routerLink]="['/app/premium/order-premium', SubscriptionTier.ELITE]"
              >
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.FREE">{{
                  'pricing.je_minscris' | translate
                }}</ng-container>
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.PREMIUM_PLUS">{{
                  'pricing.convertir' | translate
                }}</ng-container>
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.ELITE">{{
                  'pricing.prolonger' | translate
                }}</ng-container>
              </a>
              <div class="pricing-block_payment-3x">
                <ng-container *ngIf="currentSubscriptionTier !== SubscriptionTier.ELITE">{{
                  'pricing.paiement_3_fois' | translate
                }}</ng-container>
                <ng-container *ngIf="currentSubscriptionTier === SubscriptionTier.ELITE">{{
                  'pricing.formule_actuelle' | translate
                }}</ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div *ngIf="pricingService.pricingSections" class="hidden md:block mt-12">
      <div
        class="grid gap-8"
        [ngClass]="{
          'grid-cols-[1fr_3fr]': languageService.isEliteEnabled,
          'grid-cols-[1fr_2fr]': !languageService.isEliteEnabled
        }"
      >
        <div></div>
        <div
          class="bg-theme-white grid gap-8 py-4 text-16 font-extrabold text-center"
          [ngClass]="{
            'grid-cols-3': languageService.isEliteEnabled,
            'grid-cols-2': !languageService.isEliteEnabled
          }"
        >
          <div>{{ 'pricing.gratuit' | translate }}</div>
          <div>{{ 'pricing.premium_plus' | translate }}</div>
          <div *ngIf="languageService.isEliteEnabled">{{ 'pricing.elite' | translate }}</div>
        </div>
      </div>

      <div *ngFor="let section of pricingService.pricingSections">
        <app-pricing-features-table-section
          [section]="section"
          class="grid gap-8 border-b border-theme-gray-eighteen"
          [ngClass]="{
            'grid-cols-[1fr_3fr]': languageService.isEliteEnabled,
            'grid-cols-[1fr_2fr]': !languageService.isEliteEnabled
          }"
        ></app-pricing-features-table-section>

        <app-pricing-features-table-row
          *ngFor="let row of section.rows"
          [row]="row"
          class="grid gap-8 border-b border-theme-gray-eighteen"
          [ngClass]="{
            'grid-cols-[1fr_3fr]': languageService.isEliteEnabled,
            'grid-cols-[1fr_2fr]': !languageService.isEliteEnabled
          }"
        ></app-pricing-features-table-row>

        <div
          class="grid gap-8 h-8"
          [ngClass]="{
            'grid-cols-[1fr_3fr]': languageService.isEliteEnabled,
            'grid-cols-[1fr_2fr]': !languageService.isEliteEnabled
          }"
        >
          <div></div>
          <div class="bg-theme-white"></div>
        </div>
      </div>
    </div>

    <app-landing-ancrage class="block mt-20 -mx-8"></app-landing-ancrage>

    <app-landing-feedbacks class="block -mx-8 bg-theme-white"></app-landing-feedbacks>

    <app-landing-testimonies
      *ngIf="languageService.majorTestimoniesIsEnabled"
      class="block -mx-8 -mb-8"
    ></app-landing-testimonies>
  </div>

  <div class="block-nnki-title" *ngIf="isApplicationService.isAppIos()">
    {{ 'cordova.message_ios' | translate }}
  </div>
</div>
